<dynamic-form
  *ngIf="columns && columns.length > 0"
  [apiName]="apiName"
  [label]="label"
  [group]="formGroup"
  [model]="model"
  [isShowModal]="false"
  [areaName]="areaName"
  (valueChange)="onChanged($event)"
  [columns]="columns"
  [erroremessage]="erroremessage"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <ng-container class="content">
    <div class="detail">
      <editable-grid
        [isAdd]="false"
        [isDelete]="false"
        [isEdit]="false"
        [columns]="GeneralLedgerVoucherDetails"
        [(dataList)]="model.GeneralLedgerVoucherDetails"
        [DefaultValues]="DefaultValues">
      </editable-grid>
    </div>
  </ng-container>
  <ng-container class="footer">
    <ssg-button
      icon="icon-file-document-multiple-outline"
      buttontype="button"
      (click)="createVoucher()"
      class="action-btn"
      label="صدور سند"
      size="large"
      [disabled]="model?.GeneralLedgerVoucherDetails?.length > 0"
      appearance="flat">
    </ssg-button>
    <ssg-button
      icon="icon-delete_sweep-o"
      buttontype="button"
      (click)="deleteVoucher()"
      class="action-btn"
      label="حذف سند"
      size="large"
      [disabled]="isNewRow && (!model?.GeneralLedgerVoucherDetails || model?.GeneralLedgerVoucherDetails.length <= 0)"
      appearance="flat">
    </ssg-button>
    <ssg-menu *ngIf="!isNewRow" icon="icon-print-o" class="btnstyle" tooltip="چاپ">
      <ng-container class="menuitem">
        <div>
          <div *ngFor="let report of reportKinds" class="reportbtn">
            <button class="btn" (click)="changeReport(report.value)">{{ report.name }}</button>
          </div>
        </div>
      </ng-container>
    </ssg-menu>
  </ng-container>
</dynamic-form>
